<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mt-2,mb-2"
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box">
            <v-data-table :headers="headers" :items="task_list" id="my-table-id" class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Tasks</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row >
                        <v-col cols="12" sm="3" md="3"> 
                            <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'Task Master')"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mt-4 button" v-on="on" small>Add Task</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <b>Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.name" persistent-hint
                                                        :rules="[(v) => !!v || 'required']" outlined dense
                                                        hint="For e.g. Committee work, Cultural work..."></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.delete="{ item }">
                    <div>
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class=" v-icon-size" color="red" @click="deleteItem(item)">mdi-trash-can</v-icon>
                        </v-avatar>
                    </div>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
         <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Task Master Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/NwgaSNYyz8E?si=YPfBY-uZ3eRlCnCp"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data: () => ({
        valid: false,
        overlay: false,
        videoDialog:false,
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            {
                text: "Sr.No",
                align: "left",
                sortable: false,
                value: "sr_no",
            },
            {
                text: "Name",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "Status",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
            { text: "Delete", value: "delete", sortable: false },
        ],
        editedIndex: -1,
        editedItem: {
            id: "",
            name: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            name: "",
            isactive: true,
        },
        task_list:[],
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Task" : "Edit Task";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Status</th>
            </tr>`;

                this.task_list.forEach((s) => {
                    let isactive = s.isactive ? 'Yes' : 'No';
                    tab_text += `
            <tr>
                <td>${s.sr_no}</td>
                <td>${s.name}</td>
                <td>${isactive}</td>
            </tr>`;
                });

                tab_text += '</table>';

                const blob = new Blob([tab_text], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const filename = name + '.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
        },
        editItem(item) {
            this.editedIndex = this.task_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/Timesheet/editTask", this.editedItem)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.onLoad();
                                Object.assign(this.task_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Task Updated Successfully...");
                            } else if(res.data.flag == "NO"){
                                this.showSnackbar("error",res.data.msg);
                            }                          
                        })
                        .catch((error) => {
                            this.showSnackbar("error", "Something went wrong...");
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                axios
                    .post("/Timesheet/saveTask", this.editedItem)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            //window.alert(res.data.status.code)
                            this.task_list.push(this.editedItem);
                            this.showSnackbar("#4caf50", "Task Added Successfully...");
                            this.onLoad();
                        } else if (res.data.flag == "NO") {
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "Task Already Present!!!"); 
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("error", "Something went wrong...");
                        window.console.log(error);
                    });
                this.close();
            }
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/Timesheet/getTask")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.overlay = false;
                        this.task_list = res.data.task_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

       

        deleteItem(item) {

            if (!confirm("Are You Sure You Want To Delete ...?")) return;
            const formData = {
                id: item.id,

            };

            axios
                .post("/Timesheet/deleteTask", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Task Deleted Successfully..."); // show snackbar on success

                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                ;
        },
        isValidated() {
            if (this.editedItem.name) {
                return true;
            } else {
                if (!this.editedItem.name) {
                    this.errorMsg.name = true;
                }

                return false;
            }
        }, // .....end of isValidated()

        toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/Timesheet/toggleTask", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Task Status Changed Successfully !"); 
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    this.showSnackbar("#4caf50", "Something went wrong");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
